var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialEnrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "#7A1E66",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 10.3137 7 11 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C7 2.5 7 3.68629 7 7Z",
    fill: "#86BC25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialEnrolled);
export default __webpack_public_path__ + "static/media/partial-enrolled.18adcee012ae5a8ead665a0b92f95f21.svg";
export { ForwardRef as ReactComponent };